import * as Yup from 'yup';

export const getManageEmployeeWorkingHoursSchema = () => {
  return Yup.object().shape({
    year: Yup.string().required('Year is required'),
    hours: Yup.string().required('Hours is required'),
  });
};
